module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/arrow--red-d6e076ccf4657de865e5dc074194c872.svg";